/* By Anna Batura: https://codepen.io/Anna_Batura/pen/XWKQQvq */
import React from 'react';

interface AnimatedSVGProps {
  size?: number;
  color?: string;
  className?: string;
}

const AnimatedSVG: React.FC<AnimatedSVGProps> = ({
  size = 24,
  color = 'currentColor',
  className = '',
}) => {
  return (
    <div className={`flex items-center justify-center ${className}`}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <style>
          {`
            @keyframes spinner_pulse {
              0% {
                r: 0;
                opacity: 1;
              }
              100% {
                r: 11px;
                opacity: 0;
              }
            }
            .spinner_circle {
              animation: spinner_pulse 1.2s cubic-bezier(0.52, 0.6, 0.25, 0.99) infinite;
              fill: ${color};
            }
          `}
        </style>
        <circle className="spinner_circle" cx="12" cy="12" r="0" />
      </svg>
    </div>
  );
};

export default AnimatedSVG;
